import React, { Component } from 'react';
import { Grid, Row, Col, Label, Form, FormGroup, ControlLabel, FormControl, ButtonToolbar, ButtonGroup, Button, Checkbox } from 'react-bootstrap';
import Select from "react-select";
import { PropTypes } from 'prop-types';

import { LinesDraftCommand } from '../../commands/LinesDraftCommand';
import { StopsDraftCommand } from '../../commands/StopsDraftCommand';
import { TripsDraftCommand } from '../../commands/TripsDraftCommand';
import { ImportCommand } from '../../commands/ImportCommand';
import { SchedulesDraftCommand } from '../../commands/SchedulesDraftCommand';
import { LoadingSpinner } from '../../../LoadingSpinner';
import { TitleRow } from '../../../TitleRow';
import { Progressbar } from '../../../Progressbar';

export class UploadFileStep extends Component {
    static contextTypes = {
        selectApp: PropTypes.func,
        selectedProvider: PropTypes.string,
        edition: PropTypes.object,
        addEditionObserver: PropTypes.func,
        removeEditionObserver: PropTypes.func
    }

    constructor(props) {
        super(props);

        this.state = {
            commands: {
                linesDraft: new LinesDraftCommand(),
                stopsDraft: new StopsDraftCommand(),
                schedulesDraft: new SchedulesDraftCommand(),
                tripsDraft: new TripsDraftCommand(),
                import: new ImportCommand()
            },
            form: {
                file: null,
                replicateOrientationInfo: false,
                replicatePriorityInfo: false,
                deducePassings: false,
                createHighestPriorityPaths: false,
                replicateStopsInfo: false,
                replicateLineColorsInfo: true,
                replicateLineRegionsInfo: true,
                replicatePathNotes: true,
                replicatePathStopsInfo: true,
                replicateTripNotes: true,
                replicateMapPointsInfo: true,
                type: 0,
                networkEdition: 0
            },
            draft: {
                lines: 0,
                stops: 0,
                schedules: 0,
                trips: 0
            },
            styles: {
                file: null
            },
            actions: {
                isUploading: false,
                isLoadingDraftLines: true,
                isLoadingDraftStops: true,
                isLoadingDraftTrips: true,
                isLoadingDraftSchedules: true,
                isLoadingEdition: false,
                lockDraftNetwork: true,
                lockDraftPlanning: true,
            },
            result: undefined,
        };
    }

    componentDidMount() {
        const { isTransportAuthority } = this.props;

        this.context.selectApp('datamanager', false);
        this.context.addEditionObserver(this);

        if (isTransportAuthority) {
            const { form } = this.state;

            form.type = 6;

            this.setState({
                form: form,
            });
        }
    }

    componentWillUnmount() {
        this.context.removeEditionObserver(this);
    }

    // ----------------------

    startUpdate() {
        const { actions } = this.state;

        actions.lockDraftNetwork = true;
        actions.lockDraftPlanning = true;
        actions.isLoadingEdition = true;

        this.setState({
            actions: actions
        });
    }

    endUpdate() {
        const { actions } = this.state;

        actions.isLoadingEdition = false;

        this.setState({
            actions: actions
        }, () => {
            const { actions } = this.state;

            if (actions.lockDraftNetwork || actions.lockDraftPlanning) {
                this.updateDraftNetwork();
                this.updateDraftPlanning();
            }
        });
    }

    updateDraftNetwork() {
        const { actions } = this.state;
        actions.lockDraftNetwork = false;

        this.setState({
            actions: actions
        }, () => {
            this.countDraft(this.context.edition);
        });
    }

    updateDraftPlanning() {
        const { actions } = this.state;
        actions.lockDraftPlanning = false;

        this.setState({
            actions: actions
        }, () => {
            this.countDraft(this.context.edition);
        });
    }

    // ---------------------------

    countDraft(edition) {
        const { actions } = this.state;

        if (actions.lockDraftNetwork || actions.lockDraftPlanning) {
            return;
        }

        actions.isLoadingDraftLines = true;
        actions.isLoadingDraftSchedules = true;
        actions.isLoadingDraftStops = true;
        actions.isLoadingDraftTrips = true;

        this.setState({
            actions: actions
        });

        let selectedProvider = 0;
        if (this.context.selectedProvider !== undefined) {
            selectedProvider = this.context.selectedProvider.split(':')[0];
        }

        const { commands } = this.state;

        commands.linesDraft.count(
            edition.draftNetwork,
            selectedProvider,
            (a) => this.linesCountSuccessCallback(a),
            (a) => this.operationErrorCallback(a, "isLoadingDraftLines")
        );

        commands.stopsDraft.count(
            edition.draftNetwork,
            selectedProvider,
            (a) => this.stopsCountSuccessCallback(a),
            (a) => this.operationErrorCallback(a, "isLoadingDraftStops")
        );

        commands.schedulesDraft.count(
            edition.draftPlanning,
            selectedProvider,
            (a) => this.schedulesCountSuccessCallback(a),
            (a) => this.operationErrorCallback(a, "isLoadingDraftSchedules")
        );

        commands.tripsDraft.count(
            edition,
            selectedProvider,
            (a) => this.tripsCountSuccessCallback(a),
            (a) => this.operationErrorCallback(a, "isLoadingDraftTrips")
        );
    }

    linesCountSuccessCallback(result) {
        const { draft, actions } = this.state;

        actions.isLoadingDraftLines = false;
        if (undefined !== result && undefined !== result.count && "" !== result.count) {
            draft.lines = result.count;
        }

        this.setState({
            draft: draft,
            actions: actions
        });
    }

    stopsCountSuccessCallback(result) {
        const { draft, actions } = this.state;

        actions.isLoadingDraftStops = false;
        if (undefined !== result && undefined !== result.count && "" !== result.count) {
            draft.stops = result.count;
        }

        this.setState({
            draft: draft,
            actions: actions
        });
    }

    schedulesCountSuccessCallback(result) {
        const { draft, actions } = this.state;

        actions.isLoadingDraftSchedules = false;
        if (undefined !== result && undefined !== result.count && "" !== result.count) {
            draft.schedules = result.count;
        }

        this.setState({
            draft: draft,
            actions: actions
        });
    }

    tripsCountSuccessCallback(result) {
        const { draft, actions } = this.state;

        actions.isLoadingDraftTrips = false;
        if (undefined !== result && undefined !== result.count && "" !== result.count) {
            draft.trips = result.count;
        }

        this.setState({
            draft: draft,
            actions: actions
        });
    }

    uploadSuccessCallback(result) {
        const message = {
            show: true,
            message: this.renderProgressBar("isRunning", "", result, (a) => this.callImportFunction(a.id, a.parameters)),
            style: "primary",
            title: "A Ler os Dados...",
            icon: "transfer",
            noButtons: true
        };
        this.props.onUpdateStep(message);
    }

    callImportFunctionSuccessCallback(result) {
        if (!result.isRunning) {
            this.props.onUpdateStep({ show: false });
            this.props.onUpdateStep("matchProviders", {
                id: result.id,
                providers: result.providers,
                networkEdition: result.networkEdition
            });
            return;
        }

        const message = {
            show: true,
            message: this.renderProgressBar("isRunning", "", result, (a) => this.checkImportComplete(a.id)),
            style: "primary",
            title: "A Carregar os Dados...",
            icon: "transfer",
            noButtons: true
        };
        this.props.onUpdateStep(message);
    }

    completeImportProviderDataSuccessCallback(result) {
        const { actions } = this.state;

        actions.isUploading = false;

        const message = {
            show: true,
            message: this.renderProgressBar("Success"),
            style: "success",
            title: "Sucesso",
            icon: "ok"
        };
        this.props.onUpdateStep(message, undefined, true);

        this.setState({
            actions: actions
        });
    }

    renderProgressBar(statusMessage, message, data, successCallback = undefined) {
        return (
            <Progressbar statusMessage={statusMessage}
                message={message}
                data={data}
                success={successCallback}
                error={(a) => this.operationErrorCallback(a, "isUploading")} />
        );
    }

    operationErrorCallback(messageReceived, updateAction) {
        const { actions } = this.state;
        actions[updateAction] = false;

        this.setState({
            actions: actions
        });

        const message = {
            show: true,
            message: this.renderProgressBar('Error', messageReceived),
            style: "danger",
            title: "Erro",
            icon: "remove"
        };
        this.props.onUpdateStep(message, undefined);
    }

    // -----------------------

    onChangeFile(event, target) {
        const { form } = this.state;

        const uploadedFile = event.target.files[0];

        if (undefined !== uploadedFile) {
            form[target] = uploadedFile;

            this.setState({
                form: form
            });
        }
    }

    onChangeValue(event, target, valueProperty = "value") {
        const { form } = this.state;

        form[target] = event.target[valueProperty];

        this.setState({
            form: form
        });
    }

    onSelectValue(event, target, valueProperty = "value") {
        const { form } = this.state;

        form[target] = null === event ? 0 : event[valueProperty];

        this.setState({
            form: form
        });
    }

    onChangeType(type) {
        const { form } = this.state;

        form.type = type;

        this.setState({
            form: form
        });
    }

    // ---------------------------

    onUploadFile() {
        const { form, actions } = this.state;

        const styles = {
            file: null
        };

        if (null === form.file || undefined === form.file) {
            styles.file = "error";
        }

        if (null === styles.file) {
            const { commands } = this.state;

            actions.isUploading = true;

            const message = {
                show: true,
                message: this.renderProgressBar("Pending", "A preparar a leitura do ficheiro!"),
                style: "primary",
                title: "A Ler os Dados...",
                icon: "transfer",
                noButtons: true
            };
            this.props.onUpdateStep(message);

            commands.import.uploadProviderData(
                form,
                (a) => this.uploadSuccessCallback(a),
                (a) => this.operationErrorCallback(a, "isUploading")
            );
        }

        this.setState({
            form: form,
            styles: styles,
            actions: actions
        });
    }

    callImportFunction(taskId, params) {
        const { commands } = this.state;

        commands.import.importProviderData(
            taskId,
            params,
            (a) => this.callImportFunctionSuccessCallback(a),
            (a) => this.operationErrorCallback(a, "isUploading")
        );
    }

    checkImportComplete(taskId) {
        const { commands } = this.state;

        commands.import.completeImportProviderData(
            taskId,
            (a) => this.completeImportProviderDataSuccessCallback(a),
            (a) => this.operationErrorCallback(a, "isUploading")
        );
    }

    // ---------------------------

    renderNetworkEditionForm(form, edition, isTransportAuthority) {
        if (isTransportAuthority) {
            return null;
        }

        const editions = edition.getAllNetworkEditionsArray();
        const selectedEdition = editions.find(edition => edition.id === form.networkEdition);

        return (
            <FormGroup controlId="formEdition">
                <ControlLabel>Edição de Rede</ControlLabel>
                <Select className="custom-multiselect"
                    placeholder="Sem Edição de Rede Selecionada (Criar Nova)"
                    noOptionsMessage={() => "Sem Edições de Rede Configuradas"}
                    onChange={(e) => this.onSelectValue(e, "networkEdition", "id")}
                    options={editions}
                    isMulti={false}
                    isClearable={true}
                    isOptionSelected={function (a) {
                        return form.networkEdition === a.id;
                    }}
                    getOptionValue={value => value}
                    getOptionLabel={label => label.name}
                    value={selectedEdition} />
            </FormGroup>
        );
    }

    renderProviderFormDataTypesButtons(form) {
        return (
            <ButtonGroup style={{ marginLeft: "10px" }}>
                <Button active={0 === form.type} bsStyle={0 === form.type ? "primary" : "default"} onClick={() => this.onChangeType(0)}>INFO PUB V1</Button>
                <Button active={3 === form.type} bsStyle={3 === form.type ? "primary" : "default"} onClick={() => this.onChangeType(3)}>INFO PUB V2</Button>
                <Button active={4 === form.type} bsStyle={4 === form.type ? "primary" : "default"} onClick={() => this.onChangeType(4)}>INFO PUB V3</Button>
                <Button active={1 === form.type} bsStyle={1 === form.type ? "primary" : "default"} onClick={() => this.onChangeType(1)}>GTFS</Button>
                <Button active={5 === form.type} bsStyle={5 === form.type ? "primary" : "default"} onClick={() => this.onChangeType(5)}>GTFS TML</Button>
                <Button active={2 === form.type} bsStyle={2 === form.type ? "primary" : "default"} onClick={() => this.onChangeType(2)}>NETEX</Button>
            </ButtonGroup>
        );
    }

    renderTransportAuthorityFormDataTypesButtons(form) {
        return (
            <ButtonGroup style={{ marginLeft: "10px" }}>
                <Button active={6 === form.type} bsStyle={6 === form.type ? "primary" : "default"} onClick={() => this.onChangeType(6)}>GEO PACKAGE</Button>
            </ButtonGroup>
        );
    }

    renderFormDataTypes(form, isTransportAuthority) {
        if (isTransportAuthority) {
            return (
                <React.Fragment>
                    {this.renderTransportAuthorityFormDataTypesButtons(form)}
                </React.Fragment>
            );
        }

        return (
            <React.Fragment>
                {this.renderProviderFormDataTypesButtons(form)}
            </React.Fragment>
        );
    }

    renderForm(styles, isTransportAuthority) {
        const { edition } = this.context;
        const { form } = this.state;

        return (
            <Grid fluid className="margin-top-10">
                <Row>
                    <Col sm={12}>
                        <Form>
                            {this.renderNetworkEditionForm(form, edition, isTransportAuthority)}

                            <FormGroup controlId="formDataFile"
                                validationState={styles.file} >
                                <ControlLabel>Carregar Dados</ControlLabel>
                                <FormControl
                                    type="file"
                                    placeholder="Ficheiro"
                                    onChange={(e) => this.onChangeFile(e, "file")} />
                            </FormGroup>

                            <FormGroup controlId="formDataDeducePassings" >
                                <Checkbox checked={form.deducePassings} onChange={(e) => this.onChangeValue(e, "deducePassings", "checked")}>Deduzir tempos de passagem em falta</Checkbox>
                                <Checkbox checked={form.createHighestPriorityPaths} onChange={(e) => this.onChangeValue(e, "createHighestPriorityPaths", "checked")}>Criar percursos prioritários</Checkbox>
                                <Checkbox checked={form.replicateOrientationInfo} onChange={(e) => this.onChangeValue(e, "replicateOrientationInfo", "checked")}>Replicar orientação dos percursos</Checkbox>
                                <Checkbox checked={form.replicatePriorityInfo} onChange={(e) => this.onChangeValue(e, "replicatePriorityInfo", "checked")}>Replicar prioridade dos percursos</Checkbox>
                                <Checkbox checked={form.replicateStopsInfo} onChange={(e) => this.onChangeValue(e, "replicateStopsInfo", "checked")}>Replicar informação das paragens</Checkbox>
                                <Checkbox checked={form.replicateLineColorsInfo} onChange={(e) => this.onChangeValue(e, "replicateLineColorsInfo", "checked")}>Replicar informação das cores das linhas</Checkbox>
                                <Checkbox checked={form.replicateLineRegionsInfo} onChange={(e) => this.onChangeValue(e, "replicateLineRegionsInfo", "checked")}>Replicar informação das regiões das linhas</Checkbox>
                                <Checkbox checked={form.replicatePathNotes} onChange={(e) => this.onChangeValue(e, "replicatePathNotes", "checked")}>Replicar informação das notas dos percursos</Checkbox>
                                <Checkbox checked={form.replicatePathStopsInfo} onChange={(e) => this.onChangeValue(e, "replicatePathStopsInfo", "checked")}>Replicar informação das paragens dos percursos</Checkbox>
                                <Checkbox checked={form.replicateTripNotes} onChange={(e) => this.onChangeValue(e, "replicateTripNotes", "checked")}>Replicar informação das notas das viagens</Checkbox>
                                <Checkbox checked={form.replicateMapPointsInfo} onChange={(e) => this.onChangeValue(e, "replicateMapPointsInfo", "checked")}>Replicar informação dos pontos notáveis</Checkbox>
                            </FormGroup>

                            <FormGroup>
                                <ControlLabel>Tipo de dados</ControlLabel>
                                {this.renderFormDataTypes(form, isTransportAuthority)}
                            </FormGroup>
                        </Form>
                    </Col>
                </Row>
            </Grid>
        );
    }

    renderDraftInfo(draft, actions) {
        const { edition } = this.context;

        if (null === edition || actions.isLoadingEdition || actions.isLoadingDraftLines || actions.isLoadingDraftStops || actions.isLoadingDraftTrips || actions.isLoadingDraftSchedules) {
            return <LoadingSpinner />
        }

        return (
            <Grid fluid className="margin-top-15">
                <Row>
                    <Col sm={6}>
                        <Label className="panel-labels panel-label-title margin-top-10">LINHAS</Label>
                        <Label className="panel-labels panel-label-data"><span>{draft.lines}</span></Label>
                    </Col>

                    <Col sm={6}>
                        <Label className="panel-labels panel-label-title margin-top-10">PARAGENS</Label>
                        <Label className="panel-labels panel-label-data"><span>{draft.stops}</span></Label>
                    </Col>
                </Row>

                <Row>
                    <Col sm={6}>
                        <Label className="panel-labels panel-label-title margin-top-10">HORÁRIOS</Label>
                        <Label className="panel-labels panel-label-data"><span>{draft.schedules}</span></Label>
                    </Col>

                    <Col sm={6}>
                        <Label className="panel-labels panel-label-title margin-top-10">VIAGENS</Label>
                        <Label className="panel-labels panel-label-data"><span>{draft.trips}</span></Label>
                    </Col>
                </Row>
            </Grid>
        );
    }

    render() {
        const { isTransportAuthority } = this.props;
        const { draft, actions, styles } = this.state;

        return (
            <div>
                <div>
                    <TitleRow title="Importação de Dados - Carregar Informação" showSeparator={true}>
                        <ButtonToolbar className="pull-right">
                            <Button onClick={() => this.onUploadFile()}>CARREGAR</Button>
                        </ButtonToolbar>
                    </TitleRow>

                    {this.renderForm(styles, isTransportAuthority)}
                </div>

                <div className="margin-top-50">
                    <TitleRow title="Dados em Rascunho" showSeparator={true} />

                    {this.renderDraftInfo(draft, actions)}
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/datamanager/import/steps/UploadFileStep.js